import { render, staticRenderFns } from "./i-back.vue?vue&type=template&id=d0882844&scoped=true"
import script from "./i-back.vue?vue&type=script&lang=js"
export * from "./i-back.vue?vue&type=script&lang=js"
import style0 from "./i-back.vue?vue&type=style&index=0&id=d0882844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0882844",
  null
  
)

export default component.exports